import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 11a3 3 0 1 0 -3 3","key":"svg-0"}],["path",{"d":"M12.249 21.47a2 2 0 0 1 -1.662 -.57l-4.244 -4.243a8 8 0 1 1 13.655 -5.828","key":"svg-1"}],["path",{"d":"M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5","key":"svg-2"}]]

const IconMapShield = createReactComponent('outline', 'map-shield', 'MapShield', __iconNode);

export default IconMapShield;